<div
  class="odin-alert-dialog"
  [class.odin-alert-dialog-error]="data.tone === 'error'"
  data-test="core-dialog-alert"
>
  <div class="odin-alert-dialog-icon">
    <mat-icon class="outline">{{ data.icon || 'info' }}</mat-icon>
  </div>
  @if (data.title) {
    <h2 mat-dialog-title class="odin-alert-dialog-title">{{ data.title }}</h2>
  }
  <div mat-dialog-content class="odin-alert-dialog-body">
    <p class="m-0">{{ data.reason }}</p>
  </div>
  <div mat-dialog-actions class="odin-alert-dialog-actions">
    @if (data.reference) {
      <button
        mat-button
        type="button"
        (click)="copyReference()"
        data-test="core-dialog-alert-copy-reference-button"
      >
        Copy reference
      </button>
    }    <button
      mat-flat-button
      class="mon-bg-primary mon-border-primary border mon-text-primary"
      (click)="closeDialog()"
      data-test="core-dialog-alert-close-dialog-button"
    >
      {{ data.action || 'Close' }}
    </button>
  </div>
</div>
